import React, { useState } from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../utils/GlobalAPI';

const CreateTestInfluencer = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const createTestInfluencer = async () => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const response = await axios.post(`${API_ENDPOINTS.INFLUENCER}/test/pending`);
      setResult(response.data);
      console.log('✅ Test influencer created/updated:', response.data);
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Failed to create test influencer');
      console.error('❌ Error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Create Test Influencer</h1>
        
        <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <p className="text-sm text-blue-800">
            <strong>Email:</strong> vivekkumar787067@gmail.com
          </p>
          <p className="text-sm text-blue-800">
            <strong>Status:</strong> pending
          </p>
        </div>

        <button
          onClick={createTestInfluencer}
          disabled={loading}
          className={`w-full py-3 px-4 rounded-lg text-white font-semibold transition-all ${
            loading
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-gradient-to-r from-orange-400 via-pink-400 to-purple-400 hover:opacity-90'
          }`}
        >
          {loading ? 'Creating...' : 'Create/Update Test Influencer'}
        </button>

        {result && (
          <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg">
            <p className="text-green-800 font-semibold">✅ Success!</p>
            <p className="text-sm text-green-700 mt-2">{result.message}</p>
            {result.influencer && (
              <div className="mt-3 text-xs text-green-600">
                <p>ID: {result.influencer._id}</p>
                <p>Name: {result.influencer.name}</p>
                <p>Email: {result.influencer.email}</p>
                <p>Status: {result.influencer.status}</p>
              </div>
            )}
          </div>
        )}

        {error && (
          <div className="mt-6 p-4 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-800 font-semibold">❌ Error</p>
            <p className="text-sm text-red-700 mt-2">{error}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateTestInfluencer;

